import { Button } from '@thisisdevelopment/akzonobel-core';
import { ContainerInner } from 'elements';
import styled from 'styled-components';

export const DownloadDescriptions = styled(ContainerInner)`
  padding-bottom: 30px;

  h2 {
    font-size: 1.4rem;
    font-weight: 600;
  }

  p {
    font-size: 1.3rem;
    font-family: 'Source Sans Pro', sans-serif;
    margin: 0 0 0 0;
    letter-spacing: 0.05em;
  }

  .downloadWrapper {
    width: 100%;
    height: 2em;
    display: flex;
    border-bottom: 0.1rem solid #e1e1e1;
  }

  .downloadWrapper p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100vw - 150px);
  }

  .downloadWrapper:first-of-type {
    border-top: 0.1rem solid #e1e1e1;
  }

  .pdfLogo {
    height: 24px;
    padding-left: 10px;
    padding-top: 5px;
    padding-right: 10px;
  }

  .downloadLogo {
    height: 24px;
    display: block;
    margin-left: auto;
    margin-right: 10px;
    padding-top: 5px;
    cursor: pointer;
  }

  .downloadTitle {
    padding-top: 10px;
  }

  .downloadType {
    padding-top: 10px;
    font-size: 1rem;
    text-align: right;
    color: ${({ theme }) => theme.colors.brandDarkGreen};
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colors.brandGold};
    }
  }
`;

export const Summary = styled.summary`
  // this hides the ::marker for the summary
  list-style: none;
`;

export const Details = styled.details`
  &[open] {
    > ${Summary} > .downloadWrapper:last-of-type {
      border-bottom: 0;
    }
  }
`;

export const ToggleButton = styled(Button)`
  margin-top: 10px;
`;
